import React, { useEffect, useState } from "react";
import { func, string, number, bool, object } from "prop-types";
import { withGoogleLogin, withFacebookLogin } from "@quintype/bridgekeeper-js";
import { connect } from "react-redux";
import get from "lodash/get";

import SocialAuthButton from "../../atoms/SocialAuthButton";

export const SocialLogin = ({
  callbackUrl,
  redirectUrl,
  clientId,
  ssoLoginIsEnable,
  authHost,
  publisherAttributes,
  googleClientId,
  facebookId,
}) => {
  const [renderSocialLogin, setRenderSocialLogin] = useState(false);
  const oauthAuthorize = ssoLoginIsEnable
    ? `${authHost}/api/auth/v1/oauth/authorize?redirect_uri=${redirectUrl}&client_id=${clientId}&callback_uri=${callbackUrl}&response_type=code`
    : "";
  useEffect(() => {
    setRenderSocialLogin(true);
  }, []);
  if (!renderSocialLogin) {
    return null;
  }
  const FaceBookLogin = () => {
    const { serverSideLoginPath } = withFacebookLogin({
      scope: "email",
      emailMandatory: true,
      redirectUrl: encodeURIComponent(oauthAuthorize),
      appId: facebookId,
    });
    return <SocialAuthButton type="fb" href={serverSideLoginPath} lang={publisherAttributes.lang} />;
  };
  const GoogleLogin = () => {
    const { serverSideLoginPath } = withGoogleLogin({
      scope: "email",
      emailMandatory: true,
      redirectUrl: encodeURIComponent(oauthAuthorize),
      clientId: googleClientId,
    });
    return (
      <SocialAuthButton type="google" className="google" href={serverSideLoginPath} lang={publisherAttributes.lang} />
    );
  };
  return (
    <div>
      <FaceBookLogin />
      <GoogleLogin />
    </div>
  );
};

SocialLogin.propTypes = {
  getCurrentUser: func,
  callbackUrl: string,
  redirectUrl: string,
  clientId: number,
  ssoLoginIsEnable: bool,
  authHost: string,
  publisherAttributes: object,
  googleClientId: string,
  facebookId: string,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps)(SocialLogin);
